module.exports = __webpack_public_path__ + "img/tutorial_img_3.ddbdc4e3.svg";